import './LaminarFlowSVG.css';

export function LaminarFlowSVG() {
  return (
    <figure className="laminar-flow">
      <svg viewBox="0 0 320 160" className="laminar-flow__svg" role="img" aria-labelledby="laminar-title">
        <title id="laminar-title">Laminar flow filter animation</title>
        <rect x="10" y="50" width="300" height="60" rx="30" className="laminar-flow__pipe" />
        <circle cx="160" cy="80" r="22" className="laminar-flow__core" />
        <line x1="30" y1="80" x2="140" y2="80" className="laminar-flow__stream" />
        <line x1="180" y1="80" x2="290" y2="80" className="laminar-flow__stream laminar-flow__stream--out" />
        <circle cx="65" cy="80" r="6" className="laminar-flow__particle" />
        <circle cx="95" cy="80" r="4" className="laminar-flow__particle laminar-flow__particle--delayed" />
        <circle cx="235" cy="80" r="4" className="laminar-flow__particle laminar-flow__particle--exit" />
      </svg>
      <figcaption className="laminar-flow__caption">
        Smooth, aligned flow keeps heat moving where it should.
      </figcaption>
    </figure>
  );
}

export default LaminarFlowSVG;
